<template>
    <div>
        <div class="d-flex" id="wrapper">
            <!-- Sidebar -->
            <SideBar/>
            <!-- /#sidebar-wrapper -->
            <!-- Page Content -->
            <div id="page-content-wrapper">
                <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                    <div>
                        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                        </button>

                        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                        </button>
                    </div>
                    <div class="d-flex">
                        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                        <p class="text-primary mb-0 hover-cursor">&nbsp;Admin</p>
                    </div>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {{ admin }}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container">
                                <h5 class="card-title mb-4">Admin </h5>
                                <div class="search-table container-fluid">
                                    <div class="row">
                                        <div class="col-lg-3 col-sm mobile-div">
                                            Company
                                            <input type="text" name="" class="form-control" placeholder="Company" v-model="searchCompanyName">
                                        </div>
                                        <div class="col-lg-3 col-sm mobile-div">
                                            Type
                                            <multiselect v-model="searchType" :options="lesseeType" label="lesseeTypeName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Admin Type"></multiselect>
                                        </div>
                                        <div class="col-lg-3 col-sm mobile-div">
                                            Name
                                            <input type="text" class="form-control" v-model="searchName" placeholder="Name">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3 col-sm mobile-div">
                                            Phone
                                            <input type="number" @keypress="isNumber($event)" class="form-control" v-model="searchPhone" placeholder="Ex: 628xxxxxxxxxxx">
                                        </div>
                                        <div class="col-lg-3 col-sm mobile-div">
                                            Email
                                            <input type="text" class="form-control" v-model="searchEmail" placeholder="Email">
                                        </div>
                                        <div class="col-lg-3 col-sm mobile-div">
                                            Status
                                            <multiselect v-model="searchStatus" :options="lesseeStatus" label="lesseeStatusName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Admin Status"></multiselect>
                                        </div>
                                        <div class="col-lg-2 col-sm mobile-div mt-4">
                                            <button class="btn btn-primary" @click="searchData"> Search </button>
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-sm btn-primary mb-1" @click="openModal('AddAdmin')"> Add </button>
                                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                    <thead class="">
                                        <tr>
                                            <th>Company</th>
                                            <th>Name</th>
                                            <th width="150px">Phone & Email</th>
                                            <!-- <th>Email</th> -->
                                            <th width="100px">Type</th>
                                            <th width="240px">Status</th>
                                            <th width="180px">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="loadingTable == true">
                                            <td colspan="8" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                        </tr>
                                        <tr v-else-if="loadingTable == false && totalData == 0">
                                            <td colspan="8" class="text-center"> Data not available</td>
                                        </tr>
                                        <tr v-for="(data, index) in dataAdmin" :key="index" v-else>
                                            <td>{{ data.companyName }}</td>
                                            <td>{{ data.lesseeName }}</td>
                                            <td>
                                                <div style="display: flex">{{ data.lesseePhone }} <img style="width: 25px;padding-left: 5px;height: 20px" v-if="data.lesseePhoneStatus==0&&data.lesseePhone!=null" src="~@/assets/images/phone_unverify.png"><img style="width: 25px;padding-left: 5px;height: 20px" v-if="data.lesseePhoneStatus==1" src="~@/assets/images/phone_verified.png"></div>
                                                <div style="display: flex" v-if="data.lesseeEmail!=null&&data.lesseeEmail!=''">{{ data.lesseeEmail }} <img style="width: 25px;padding-left: 5px;height: 20px" v-if="data.lesseeEmailStatus==0" src="~@/assets/images/mail_unverify.png"><img style="width: 25px;padding-left: 5px;height: 20px" v-if="data.lesseeEmailStatus==1" src="~@/assets/images/mail_verified.png"></div>
                                            </td>
                                           <!--  <td>
                                                <div style="display: flex" v-if="data.lesseeEmail!=null&&data.lesseeEmail!=''">{{ data.lesseeEmail }} <img style="width: 25px;padding-left: 5px;height: 20px" v-if="data.lesseeEmailStatus==0" src="~@/assets/images/mail_unverify.png"><img style="width: 25px;padding-left: 5px;height: 20px" v-if="data.lesseeEmailStatus==1" src="~@/assets/images/mail_verified.png"></div>
                                            </td> -->
                                            <td>
                                                <span v-if="data.lesseeType != -1">{{ showLesseeType(data.lesseeType).lesseeTypeName }}</span>
                                            </td>
                                            <td>
                                                <span>{{ data.lesseeStatus !== null ? showLesseeStatus(data.lesseeStatus).lesseeStatusName : '-'}}</span><br>
                                                <span v-if="data.lastLogin"> Last Login : {{ data.lastLogin }} </span>
                                            </td>
                                            <td v-if="data.lesseeStatus==13">
                                            </td>
                                            <td v-else>
                                                <button class="btn btn-primary btn-sm mb-1" v-if="data.lesseeStatus == 0 || data.lesseeStatus == 1" @click="showEditModal('EditAdmin',data,true)"> Edit </button>
                                                <button class="btn btn-success btn-sm mb-1" v-if="data.lesseeStatus == 1 || data.lesseeStatus == 3 || data.lesseeStatus == 4||data.adminSource==2" @click="showEditModal('StatusAdmin',data,true)"> Change Status </button>
                                                <button class="btn btn-primary btn-sm mb-1" @click="showEditModal('StatusAdmin',data,false)" v-if="data.adminSource==2"> ReInvite </button>
                                                <button v-if="data.lesseeStatus === 1" class="btn btn-warning btn-sm mb-1" @click="handleMigration(data)"> Migrasi + Invite External </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div id="wrapperr">
                                    <div id="c1" class="d-flex align-items-center">
                                        <div style="margin-right: 10px;">
                                            <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData">
                                                <option value="10">10</option>
                                                <option value="40">40</option>
                                                <option value="80">80</option>
                                            </select>
                                        </div>
                                        <div class="alignLeft total-data">
                                            Total Data {{ totalData }}
                                        </div>
                                    </div>
                                    <div id="c2">
                                        <div class="pagination p8 alignRight">
                                            <ul>
                                                <a class="is-active link" @click="toDataPage(currentPage-1, itemPerPage)" v-if="currentPage != 1">
                                                    <li>{{'<'}}</li>
                                                </a>
                                                <a class="page">
                                                    <li>{{ currentPage }} of {{ totalPage }} page</li>
                                                </a>
                                                <a class="is-active link" @click="toDataPage(currentPage+1, itemPerPage)" v-if="currentPage != totalPage">
                                                    <li>{{'>'}}</li>
                                                </a>
                                            </ul>
                                        </div>
                                    </div>
                                </div>​
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /#page-content-wrapper -->
            <!-- modalAddEmployee -->
            <div class="modal fade" id="modalAddAdmin" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title" v-if="mShowModal == 0">Add New Admin </h4>
                                <h4 class="modal-title" v-else-if="mShowModal == 1">Edit Admin </h4>
                                <h4 class="modal-title" v-else-if="mShowModal == 2">Change Status Admin</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal" @click="cancelAddEdit">&times;</button>
                        </div>

                        <div class="modal-body">
                            <div class="one-line" v-if="selectedEdit==null">
                                <label class="ol-label"> Lessee Name </label>
                                <label class="ol-titik2">:</label>
                                <input v-if="mShowModal == 2 || (mShowModal == 1 && selectedEdit.companyId!=null)" type="lessename" name="lessename" class="form-control" v-model="addCompany.companyName" :disabled="true">
                                <multiselect v-else v-model="addCompany" :options="dataCompany" label="companyName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Lessee Name"></multiselect>
                            </div>
                            <div class="one-line" v-if="mShowModal == 1 && selectedEdit.adminSource!=3">
                                <label class="ol-label"> Admin Type </label>
                                <label class="ol-titik2">:</label>
                                <input v-if="mShowModal ==2" type="lessename" name="lessename" class="form-control" v-model="addType.lesseeTypeName" :disabled="true">
                                <multiselect v-else v-model="addType" :options="lesseeTypeAdd" label="lesseeTypeName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Admin Type"></multiselect>
                            </div>
                            <div class="one-line" v-if="mShowModal != 0 && selectedEdit.adminSource != 2">
                                <label class="ol-label"> Admin Name </label>
                                <label class="ol-titik2">:</label>
                                <input type="name" name="name" class="form-control" v-model="addName" :disabled="mShowModal ==2">
                            </div>
                            <div class="one-line" v-if="mShowModal == 1">
                                <label class="ol-label"> Admin Phone </label>
                                <label class="ol-titik2">:</label>
                                <input type="text" name="phone_number" class="form-control" v-model.trim="addPhone" @keypress="isNumber($event)" placeholder="Ex: 628xxxxxxxxxxx" :disabled="mShowModal ==2">
                            </div>
                            <div class="one-line" v-if="mShowModal !=2">
                                <label class="ol-label"> Admin Email </label>
                                <label class="ol-titik2">:</label>
                                <div class="w-100">
                                    <input type="email" name="mail" v-model="addEmail" :disabled="mShowModal ==2" :class="{ 'form-control': true,'border-red' : showErrorEmail}">
                                    <p v-if="showErrorEmail" class="text-danger m-0 p-0" style="font-size: 12px">Email is not valid</p>
                                </div>
                            </div>
                            <div class="one-line" v-if="mShowModal == 1">
                                <label class="ol-label"> Admin Division </label>
                                <label class="ol-titik2">:</label>
                                <input type="name" name="name" class="form-control" v-model="addDivision" :disabled="mShowModal ==2">
                            </div>
                            <div class="one-line" v-if="mShowModal == 1">
                                <label class="ol-label"> Admin Position </label>
                                <label class="ol-titik2">:</label>
                                <input type="name" name="name" class="form-control" v-model="addPosition" :disabled="mShowModal ==2">
                            </div>
                            <!-- CHANGE STATUS -->
                            <div v-if="loadingAdmins&&mShowModal ==2">
                                <center><img src="~@/assets/images/load-button.gif"></center>
                            </div>
                            <div class="one-line" v-if="mShowModal ==2 && !loadingAdmins">
                                <label class="ol-label"> Admin Status </label>
                                <label class="ol-titik2">:</label>
                                <multiselect v-model="addStatus" :options="lesseeStatusAdd" label="lesseeStatusName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Admin Status"></multiselect>
                            </div>
                            <div class="one-line" v-if="mShowModal ==2 && (this.isAdmin || this.hasOrder) &&addStatus.lesseeStatus==2 && !loadingAdmins">
                                <label class="ol-label"> Choose New Admin </label>
                                <label class="ol-titik2">:</label>
                                <multiselect v-model="addLesseeUpdate" :options="companyAdmins" label="lesseeName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Choose New Admin"></multiselect>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                            <!-- ADD ADMIN -->
                            <button type="button" class="btn btn-primary btn-sm" @click="checkAddAdmin()" v-if="loadingButtonAdd == false && mShowModal ==0">Save</button>
                            <!-- EDIT ADMIN -->
                            <button type="button" class="btn btn-primary btn-sm" @click="checkNoEdit()" v-else-if="loadingButtonAdd == false && mShowModal ==1">Save</button>
                            <!-- CHANGE STATUS ADMIN -->
                            <button type="button" class="btn btn-primary btn-sm" @click="doEditStatusAdmin()" v-else-if="loadingButtonAdd == false && mShowModal ==2 && !loadingAdmins">Save</button>
                            <!-- LOADING BUTTON -->
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
            <div class="modal fade" id="modalReinviteAdmin" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Reinvite Admin</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure want to resend email invitation to {{ deleteEmail }} ?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">No</button>
                            <button type="button" class="btn btn-primary btn-sm" @click="doEditAdmin(1)">Yes, Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import swal from 'sweetalert'
import SideBar from '../SideBar'
import validateMixin from '../../mixins/validate'
export default {
    name: 'ResolutionCenterPage',
    mixins: [validateMixin],
    components: {
        SideBar,
        Multiselect
    },
    data() {
        return {
            spaceRegex: /[\u00A0\uFEFF\u202F]/g,
            source: "",
            admin: "",
            permission: [],
            viewDashboard: false,
            viewAdmin: false,
            editAdmin: false,

            dataAdmin: [],
            totalPage: 0,
            totalData: 0,
            currentPage: 1,
            deleteEmail: '',

            orderId: "",
            companyName: "",
            dataCompany: [],
            addCompanyName: "",
            picName: "",
            phoneNumber: "",
            statusOrder: "",

            searchCompanyName: '',
            searchType: {
                lesseeType: 'All',
                lesseeTypeName: 'All'
            },
            lesseeType: [],
            lesseeTypeAdd: [],
            searchName: '',
            searchPhone: '',
            searchEmail: '',
            searchStatus: {
                lesseeStatus: 'All',
                lesseeStatusName: 'All'
            },
            lesseeStatus: [],
            lesseeStatusAdd: [],

            mShowModal: 0, // 0 add, 1 edit, 2 change status
            fromInvite: false,

            addCompany: [],
            addType: [],
            addStatus: [],
            addName: '',
            addPhone: '',
            addEmail: '',
            addDivision: '',
            addPosition: '',
            addAdminSource: '',
            selectedId: '',
            selectedEdit: '',
            addLesseeUpdate: [],

            companyAdmins: [],
            isAdmin: false,
            hasOrder: false,
            loadingAdmins: true,
            emailEdited:false,

            loadingTable: true,
            loadingButtonAdd: false,
            adminId: "",
            sourceSelect: [],
            newSource: '',
            employeeSource: '',
            showErrorEmail: false,
            itemPerPage : 10,
        }
    },
    methods: {
        sendLog(w, x) {
                var today = new Date();
                var month = today.getMonth() + 1
                if (month < 10) {
                    month = '0' + month
                }
                var dateDay = today.getDate()
                if (dateDay < 10) {
                    dateDay = '0' + dateDay
                }
                var hours = today.getHours()
                if (hours < 10) {
                    hours = '0' + hours
                }
                var minutes = today.getMinutes()
                if (minutes < 10) {
                    minutes = '0' + minutes
                }
                var second = today.getSeconds()
                if (second < 10) {
                    second = '0' + second
                }
                var date = today.getFullYear() + '-' + month + '-' + dateDay;
                var time = hours + ":" + minutes + ":" + second;
                var dateTime = date + ' ' + time;
                var admin = this.admin
                var command = 'add-logs'
                    // var productName = this.productNameChoose

                this.$http.post(process.env.LOG_URL+"/company/"+x,{
                    codeLogs: w,
                    params: [],
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                })
                .catch(error => {
                    console.log(error)
                })
            },
            // validateEmail(email) {
            //     var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            //     return re.test(email);
            // },
            cancelAddEdit() {
                this.showErrorEmail = false
            },
            checkAddAdmin() {
                if (this.addCompany != null && this.addCompany.companyId == null) {
                    swal("Sorry", "Lessee Name must be fill", "error", {
                        button: "Ok",
                    })
                } else if (!this.validateEmail(this.addEmail)) {
                    this.showErrorEmail = true
                    swal("Sorry", "Admin Email must be filled or valid format", "error", {
                        button: "Ok",
                    })
                } else {
                    this.showErrorEmail = false
                    this.addNewAdmin()
                }
            },
            checkNoEdit() {
                if (this.addType == this.showLesseeType(this.selectedEdit.lesseeType) && this.addName == this.selectedEdit.lesseeName && this.addPhone == this.selectedEdit.lesseePhone && this.addEmail == this.selectedEdit.lesseeEmail && this.addDivision == this.selectedEdit.lesseeDivision && this.addPosition == this.selectedEdit.lesseePosition) {
                    swal("Success", "Admin Updated", "success", {
                        button: "Ok",
                    })
                    $('#modalAddAdmin').modal('hide')
                    $('#modalReinviteAdmin').modal('hide')

                    this.getData()
                    this.loadingButtonAdd = false
                } else {
                    this.checkEditAdmin()
                }
            },
            checkEditAdmin() {
                if (this.addType != null && this.addType.lesseeType == null) {
                    swal("Sorry", "Admin Type must be filled", "error", {
                        button: "Ok",
                    })
                } else if (this.addName == '') {
                    swal("Sorry", "Admin Name must be filled", "error", {
                        button: "Ok",
                    })
                } else if (this.addPhone === null || this.addPhone == '' || this.addPhone.substring(0, 3) != '628') {
                    swal("Sorry", "Admin Phone must be filled or valid format", "error", {
                        button: "Ok",
                    })
                } else if (!this.validateEmail(this.addEmail)) {
                    this.showErrorEmail = true
                    swal("Sorry", "Admin Email must be filled or valid format", "error", {
                        button: "Ok",
                    })
                } else {
                    this.showErrorEmail = false
                    this.doEditAdmin(0)
                }
            },
            addNewAdmin() {
                this.loadingButtonAdd = true
                this.$http.post(process.env.ADD_ADMIN, {
                        companyId: this.addCompany.companyId,
                        lesseeName: this.addName !== null ? this.addName.replace(this.spaceRegex, ' ') : this.addName,
                        lesseeEmail: this.addEmail !== null ? this.addEmail.replace(this.spaceRegex, ' ') : this.addEmail,
                        lesseeDivision: this.addDivision,
                        lesseePosition: this.addPosition,
                        lesseePhone: this.addPhone,
                        lesseeType: 0,
                        lesseeStatus: 1,
                        adminId: this.adminId
                    }, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                            $('#modalAddAdmin').modal('hide')
                        } else if (response.data.status == 201) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else if (response.data.status == 200) {
                            swal("Success", response.data.message, "success", {
                                button: "Ok",
                            })
                            // if (response.data.content.newData == false) {
                            //     this.sendLog(59, response.data.content.companyId)
                            // } else {
                            //     this.sendLog(46, response.data.content.companyId)
                            // }

                        }
                        $('#modalAddAdmin').modal('hide')

                        this.getData()
                        this.loadingButtonAdd = false

                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
            },
            doEditAdmin(sm) {
                this.loadingButtonAdd = true
                this.$http.post(process.env.EDIT_ADMIN, {
                        companyId: this.addCompany.companyId,
                        lesseeName: this.addName !== null ? this.addName.replace(this.spaceRegex, ' ') : this.addName,
                        lesseeEmail: this.addEmail !== null ? this.addEmail.replace(this.spaceRegex, ' ') : this.addEmail,
                        lesseeDivision: this.addDivision,
                        lesseePhone: this.addPhone,
                        lesseePosition: this.addPosition,
                        lesseeType: this.addType.lesseeType,
                        lesseeStatus: this.addStatus.lesseeStatus,
                        adminId: this.adminId,
                        lesseeId: this.selectedId,
                        adminSource: this.addAdminSource,
                        sendMail: sm
                    }, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                            $('#modalAddAdmin').modal('hide')
                        } else if (response.data.status == 201) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else if (response.data.status == 200) {
                            console.log('wkwkwkw')
                            swal("Success", response.data.message, "success", {
                                button: "Ok",
                            })

                            // this.sendLog(59, response.data.data.companyId)

                        }
                        $('#modalAddAdmin').modal('hide')
                        $('#modalReinviteAdmin').modal('hide')

                        this.getData()
                        this.loadingButtonAdd = false

                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            this.loadingButtonAdd = false
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
            },
            doEditStatusAdmin() {
                if(this.isAdmin == false && this.hasOrder == false){
                    this.addLesseeUpdate.lesseeId = this.selectedId
                }
                if (this.addStatus != null && this.addStatus.lesseeStatus == null) {
                    swal("Sorry", "Admin Status must be fill", "error", {
                        button: "Ok",
                    })
                } else if (this.addLesseeUpdate != null && this.addLesseeUpdate.lesseeId == null && this.addStatus != null && this.addStatus.lesseeStatus == 2) {
                    swal("Sorry", "New Admin must be fill", "error", {
                        button: "Ok",
                    })
                } else {
                    this.loadingButtonAdd = true
                    this.$http.post(process.env.CHANGE_STATUS_ADMIN, {
                            companyId: this.addCompany.companyId,
                            lesseeName: this.addName,
                            lesseeEmail: this.addEmail,
                            lesseeDivision: this.addDivision,
                            lesseePosition: this.addPosition,
                            lesseePhone: this.addPhone,
                            lesseeType: this.addType.lesseeType,
                            lesseeStatus: this.addStatus.lesseeStatus,
                            adminId: this.adminId,
                            lesseeId: this.selectedId,
                            isAdmin: this.isAdmin,
                            lesseeIdUpdate: this.addLesseeUpdate.lesseeId
                        }, {
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 201) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                        button: "Ok",
                                    })
                                    // if (response.data.content.newData == false) {
                                    //     this.sendLog(59, response.data.content.companyId)
                                    // } else {
                                    //     this.sendLog(46, response.data.content.companyId)
                                    // }

                            }
                            $('#modalAddAdmin').modal('hide')

                            this.getData()
                            this.loadingButtonAdd = false

                        })
                        .catch(error => {
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                }
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            searchData() {
                var handleStatus = this.searchStatus.lesseeStatus.toString()
                if (this.searchStatus.lesseeStatus == 0) {
                    handleStatus = '100'
                }

                this.$http.post(process.env.SEARCH_ADMIN, {
                    companyName: this.searchCompanyName !== null ? this.searchCompanyName.replace(this.spaceRegex, ' ') : this.searchCompanyName,
                    lesseeType: this.searchType.lesseeType.toString(),
                    lesseeStatus: handleStatus,
                    lesseeName: this.searchName !== null ? this.searchName.replace(this.spaceRegex, ' ') : this.searchName,
                    lesseePhone: this.searchPhone,
                    lesseeEmail: this.searchEmail !== null ? this.searchEmail.replace(this.spaceRegex, ' ') : this.searchEmail,
                    page: '1',
                    itemPerPage: this.itemPerPage
                }, {
                    headers: {
                        'Asani-Token': localStorage.getItem('jwt')
                    }
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })
                    } else {
                        this.dataAdmin = response.data.data.data
                        this.totalPage = response.data.data.totalPage
                        this.totalData = response.data.data.totalData
                        this.currentPage = Number(response.data.data.currentPage)
                        this.loadingTable = false
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            },
            toDataPage(pagePost, itemPerPage) {
                this.loadingTable = true

                this.$router.push({
                    path: '/partnership/admin',
                    query: {
                        companyName: this.searchCompanyName,
                        lesseeType: this.searchType.lesseeType,
                        lesseeTypeName: this.searchType.lesseeTypeName,
                        lesseeName: this.searchName,
                        lesseePhone: this.searchPhone,
                        lesseeEmail: this.searchEmail,
                        lesseeStatus: this.searchStatus.lesseeStatus,
                        lesseeStatusName: this.searchStatus.lesseeStatusName,
                        page: pagePost,
                        itemPerPage : itemPerPage
                    }
                })
            },
            toPage(e) {
                this.$router.push(e)
            },
            async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
                localStorage.removeItem('jwt')
                localStorage.removeItem('admin_name')
                localStorage.removeItem('roles')
                localStorage.removeItem('user_email')
                localStorage.removeItem('admin_id')
                localStorage.removeItem('changeCatalogPermission')
                this.$router.push('/')
            },
            cekLogin() {
                if (localStorage.getItem('jwt') == null) {
                    this.$router.push('/')
                }
            },
            cekPermission() {
                this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
                for (var i = 0; i < this.permission.length; i++) {
                    if (this.permission[i] == "14.1") {
                        this.viewAdmin = true
                    }
                    if (this.permission[i] == "14.2") {
                        this.editAdmin = true
                    }
                }
                if (this.viewAdmin == false) {
                    this.$router.push('/')
                }
            },
            sidebar() {
                $("#wrapper").toggleClass("toggled");
            },
            showEditModal(nameModal, data, show) {
                this.addType = this.showLesseeType(data.lesseeType)
                this.addStatus = this.showLesseeStatus(data.lesseeStatus)
                this.addName = data.lesseeName
                this.addPhone = data.lesseePhone
                this.addEmail = data.lesseeEmail
                this.addDivision = data.lesseeDivision
                this.addPosition = data.lesseePosition
                this.addAdminSource = data.adminSource
                this.selectedId = data.lesseeId
                this.selectedEdit = data
                this.addLesseeUpdate = []
                this.loadingAdmins = true
                this.addCompany = []
                this.addCompany.companyId = -1
                this.addCompany.companyName = "nothing"
                this.deleteEmail = data.lesseeEmail
                if (data.lesseeStatus == 11) { // invite
                    this.fromInvite = true
                } else {
                    this.fromInvite = false
                }
                if (data.adminSource == 1) {
                    this.addCompany.companyId = data.companyId
                    this.addCompany.companyName = data.companyName
                } else if (data.adminSource != 3) {
                    this.addCompany = this.choosenCompany(data.companyId)
                }
                if (data.lesseeStatus != 0 && data.adminSource == 0) {
                    this.$http.post(process.env.GET_COMPANY_ADMINS, {
                            companyId: data.companyId,
                            lesseeId: data.lesseeId,
                            adminSource: data.adminSource
                        }, {
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else {
                                this.companyAdmins = response.data.content.data
                                this.isAdmin = response.data.content.isAdmin
                                this.hasOrder = response.data.content.hasOrder
                                this.initLesseeStatus()
                                this.loadingAdmins = false
                            }
                        })
                        .catch(error => {
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                } else {
                    this.initLesseeStatus()
                    this.loadingAdmins = false
                }
                if (show == true) {
                    this.openModal(nameModal)
                } else {
                    $("#modalReinviteAdmin").modal('show')
                }
            },
            choosenCompany(id) {
                for (var i = 0; i < this.dataCompany.length; i++) {
                    if (id == this.dataCompany[i].companyId) {
                        return this.dataCompany[i]
                    }
                }
            },
            openModal(x) {
                if (x == 'AddAdmin') {
                    this.fromInvite = false
                    this.selectedEdit = null
                    this.mShowModal = 0
                    this.addCompany = []
                    this.addType = []
                    this.addName = ''
                    this.addPhone = ''
                    this.addEmail = ''
                    this.addDivision = ''
                    this.addPosition = ''
                } else if (x == 'EditAdmin') {
                    this.mShowModal = 1
                } else {
                    this.mShowModal = 2
                }

                $("#modalAddAdmin").modal('show')
            },
            showLesseeType(id) {
                for (var i = 0; i < this.lesseeType.length; i++) {
                    if (id == this.lesseeType[i].lesseeType) {
                        return this.lesseeType[i]
                    }
                }
            },
            showLesseeStatus(id) {
                for (var i = 0; i < this.lesseeStatus.length; i++) {
                    if (id == this.lesseeStatus[i].lesseeStatus) {
                        return this.lesseeStatus[i]
                    }
                }
            },
            initLesseeType() {
                this.lesseeType = []
                this.lesseeTypeAdd = []

                this.lesseeType.push({
                    lesseeType: 'All',
                    lesseeTypeName: 'All'
                })
                this.lesseeType.push({
                    lesseeType: 0,
                    lesseeTypeName: 'Order PIC'
                })
                this.lesseeType.push({
                    lesseeType: 1,
                    lesseeTypeName: 'Finance PIC'
                })
                this.lesseeType.push({
                    lesseeType: 2,
                    lesseeTypeName: 'User Ticket'
                })

                for (var i = 0; i < this.lesseeType.length; i++) {
                    if (i != 0) {
                        this.lesseeTypeAdd.push(this.lesseeType[i])
                    }
                }

            },
            initLesseeStatus() {
                this.lesseeStatus = []
                this.lesseeStatusAdd = []

                this.lesseeStatus.push({
                    lesseeStatus: 'All',
                    lesseeStatusName: 'All'
                })
                this.lesseeStatus.push({
                    lesseeStatus: 0,
                    lesseeStatusName: 'User'
                })
                this.lesseeStatus.push({
                    lesseeStatus: 1,
                    lesseeStatusName: 'Assigned'
                })
                this.lesseeStatus.push({
                    lesseeStatus: 2,
                    lesseeStatusName: 'Revoked'
                })
                this.lesseeStatus.push({
                    lesseeStatus: 3,
                    lesseeStatusName: 'Suspended'
                })
                this.lesseeStatus.push({
                    lesseeStatus: 4,
                    lesseeStatusName: 'User Ticket'
                })
                this.lesseeStatus.push({
                    lesseeStatus: 11,
                    lesseeStatusName: 'Invited'
                })
                this.lesseeStatus.push({
                    lesseeStatus: 13,
                    lesseeStatusName: 'Canceled'
                })
                if (this.selectedEdit.adminSource == 2) {
                    this.lesseeStatusAdd.push({
                        lesseeStatus: 13,
                        lesseeStatusName: 'Cancel'
                    })
                } else {

                    if (this.addStatus.lesseeStatus != 1) {
                        this.lesseeStatusAdd.push({
                            lesseeStatus: 1,
                            lesseeStatusName: 'Assigned'
                        })
                    }

                    if (this.companyAdmins != null && this.companyAdmins.length > 0 && this.addStatus.lesseeStatus != 4) {
                        this.lesseeStatusAdd.push({
                            lesseeStatus: 2,
                            lesseeStatusName: 'Revoke'
                        })
                    }
                    if (this.addStatus.lesseeStatus != 3 && this.addStatus.lesseeStatus != 4) {
                        this.lesseeStatusAdd.push({
                            lesseeStatus: 3,
                            lesseeStatusName: 'Suspend'
                        })
                    }
                }
            },
            getData() {
                this.$http.get(process.env.GET_ALL_COMPANY_ADMIN, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else {
                            this.dataCompany = response.data.content
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })

                this.currentPage = this.$route.query.page
                this.doSearch(this.currentPage)

                this.$http.get(process.env.GET_LESSEE_SOURCE, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else {
                            this.sourceSelect = response.data.data
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
            },
            doSearch(pagePost) {
                this.searchCompanyName = this.$route.query.companyName
                this.searchName = this.$route.query.lesseeName
                this.searchPhone = this.$route.query.lesseePhone
                this.searchEmail = this.$route.query.lesseeEmail
                this.searchType.lesseeType = this.$route.query.lesseeType
                this.searchType.lesseeTypeName = this.$route.query.lesseeTypeName
                this.searchStatus.lesseeStatus = this.$route.query.lesseeStatus
                this.searchStatus.lesseeStatusName = this.$route.query.lesseeStatusName
                this.itemPerPage = this.$route.query.itemPerPage

                var handleStatus = this.searchStatus.lesseeStatus
                if (this.searchStatus.lesseeStatus == 0) {
                    handleStatus = '100'
                }

                this.$http.post(process.env.SEARCH_ADMIN, {
                        companyName: this.searchCompanyName !== null ? this.searchCompanyName.replace(this.spaceRegex, ' ') : this.searchCompanyName,
                        lesseeType: this.searchType.lesseeType,
                        lesseeStatus: handleStatus,
                        lesseeName: this.searchName !== null ? this.searchName.replace(this.spaceRegex, ' ') : this.searchName,
                        lesseePhone: this.searchPhone,
                        lesseeEmail: this.searchEmail !== null ? this.searchEmail.replace(this.spaceRegex, ' ') : this.searchEmail,
                        page: pagePost.toString(),
                        itemPerPage: this.itemPerPage
                    }, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else {
                            this.dataAdmin = response.data.data.data
                            this.totalPage = response.data.data.totalPage
                            this.totalData = response.data.data.totalData
                            this.currentPage = Number(response.data.data.currentPage)
                            this.loadingTable = false
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
            },
            async handleMigration({lesseeId}) {
                try {
                    const response = await this.$http.post(process.env.MIGRATION_ADMIN,{
                        userId: lesseeId,
                    },{
                        headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    if (response.data.status !== 200) {
                        swal("Error", response.data.message, "error", {
                            button: "Ok",
                        })
                    } else {
                        swal("Success", response.data.message || "Successfully migrate and invite admin", "success", {
                            button: "Ok",
                        })
                    }
                }catch(error) {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                }
            }
    },
    created() {
        this.initLesseeType()
        this.initLesseeStatus()
        this.getData()
        this.admin = localStorage.getItem('admin_name')
        this.adminId = localStorage.getItem('admin_id')
        this.cekLogin()
        this.cekPermission()
    }
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.border-red{
    border-color:red;
    }
  .one-line .ol-titik2{
    width: 15px;
    margin: 2px 0px;
  }
  .one-line .ol-label{
    width: 188px;
    margin: 2px 0px;
  }
  .one-line{
    display: flex;
    margin: 5px 0px;
  }
  .pagination{
  padding: 0px 0;
  }

  .pagination ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
  }

  .pagination a{
  display: inline-block;
  padding: 1px 6px;
  color: #222;
  }

  .p8 a{
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
  }

  .p8 a:hover{
  text-decoration: none;
  }
  .p8 a.page:hover{
  text-decoration: none;
  color: #fff;
  }

  .p8 .is-active{
  background-color: #fff;
  color: #2797FB;
  }

  .alignleft {
  float: left;
  }
  .alignright {
  float: right;
  }

  .pagg{
  display: inline-flex;
  overflow:auto;
  }

  .total-data{
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
  }
  #wrapperr{
    overflow:auto;
    margin: 5px 3px;
  }

  #c1{
   float:left;
  }

  #c2{
  float: right;  
  }

  .search-table{
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
  }
  .active{
  color: #2797FB;
  }
  .right-dropdown{
  margin-left: 7px;
  }
  .account-div{
  margin: 2px 2px;
  }
  .right-arrow{
  margin-left: auto;
  }
  .brand-logo{
  width: 120px;
  }
  .menu-title{
  margin-left: 1.125rem;
  }
  .menu-title-order{
  margin-left: 1.95rem;
  }
  .menu-title-payment{
  margin-left: 1.525rem;
  }

  ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
  }

  li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
  }

  li a.active {
  background-color: #4CAF50;
  color: white;
  }

  li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
  }
  .nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
  }
  .nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
  }
  .nav-side-menu .toggle-btn {
  display: none;
  }
  .nav-side-menu ul,
  .nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
  }
   .nav-side-menu ul :not(collapsed) .arrow:before,
   .nav-side-menu li :not(collapsed) .arrow:before {
    font-family: FontAwesome;
    content: "\f078";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu ul .active,
  .nav-side-menu li .active {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
  }
  .nav-side-menu ul .sub-menu li.active,
  .nav-side-menu li .sub-menu li.active {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li.active a,
  .nav-side-menu li .sub-menu li.active a {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li,
  .nav-side-menu li .sub-menu li {
    background-color: #181c20;
    border: none;
    line-height: 28px;
    border-bottom: 1px solid #23282e;
    margin-left: 0px;
  }
  .nav-side-menu ul .sub-menu li:hover,
  .nav-side-menu li .sub-menu li:hover {
    background-color: #020203;
  }
  .nav-side-menu ul .sub-menu li:before,
  .nav-side-menu li .sub-menu li:before {
    font-family: FontAwesome;
    content: "\f105";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu li {
    padding-left: 0px;
    border-left: 3px solid #2e353d;
    border-bottom: 1px solid #23282e;
  }
  .nav-side-menu li a {
    text-decoration: none;
    color: #e1ffff;
  }
  .nav-side-menu li a i {
    padding-left: 10px;
    width: 20px;
    padding-right: 20px;
  }
  .nav-side-menu li:hover {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    -ms-transition: all 1s ease;
    transition: all 1s ease;
  }
  @media (max-width: 767px) {
    .nav-side-menu {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
    }
    .nav-side-menu .toggle-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10 !important;
      padding: 3px;
      background-color: #ffffff;
      color: #000;
      width: 40px;
      text-align: center;
    }
    .brand {
      text-align: left !important;
      font-size: 22px;
      padding-left: 20px;
      line-height: 50px !important;
    }
  }
  @media (min-width: 767px) {
    .nav-side-menu .menu-list .menu-content {
      display: block;
    }
  }
  @media (max-width: 573px){
    .mobile-div{
      padding: 2px 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Partnership/AdminPage.vue